import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 8px;
  color: ${props => props.theme.colors.color6b7786};
  font: normal normal normal 14px/17px Inter;
`

export const Label = styled.span`
  font-weight: bold;
`

export const Value = styled.span``
